<template>
  <div class="dashboard">
    <br>
    <v-alert
      v-show="fechar"
      dismissible
      dense
      text
      type="success"
    >
      Bem-Vindo à <strong>Church System</strong>
    </v-alert>

    <v-alert
      color="info"
      border="left"
      elevation="2"
      colored-border
    >
      Informações de Cultos!
    </v-alert>
    <v-slide-group
      center-active
      show-arrows
    >
      <v-row :justify="posicao">
        <media-presenca-por-culto-domingo-vue />
      </v-row>
    </v-slide-group>
    <br>

    <v-alert
      color="info"
      border="left"
      elevation="2"
      colored-border
    >
      Informações de Valores de Entradas!
    </v-alert>
    <v-slide-group
      center-active
      show-arrows
    >
      <v-row :justify="posicao">
        <TotalMensalVue />
        <TotalOfertaMensalVue />
        <TaxaMensalVue v-show="showCardTaxa" />
        <TotalOfertasMissoes v-show="showCardMissoes" />
      </v-row>
    </v-slide-group>

    <br>
    <v-alert
      color="info"
      border="left"
      elevation="2"
      colored-border
    >
      Informações em Gráficos!
    </v-alert>

    <br>
    <v-row justify="left">
        <ChartNovosMembros />
        <br>
        <chart-total-dizimo-meses class="chartTotalMonths"/>
        <ChartTotalOfertaMonthVue />
    </v-row>

    <br>
    <br>
    <!-- <v-alert
      color="info"
      border="left"
      elevation="2"
      colored-border
    >
      Aniversariantes do Mês!
    </v-alert>

    <v-row justify="left">
      <v-slide-group
        center-active
        show-arrows
      >
        <v-card
          height="100"
          width="auto"
          padding="0"
          margin="0"
          class="ma-4"
          color="#952175"
          v-for="item in Birthday" :key="item.day"
          @click="whatsappLink(item.phone)"
        >
          <v-card-text
            class="d-flex white--text justify-space-between align-center"
          >
            <v-avatar
              size="60"
              color="white"
              style="border: 3px solid #444"
            >
                <span class="text-h5" style="color: #952175; font-weight: bold;"> {{ item.day }}</span>
            </v-avatar>
            <v-card-actions class="d-flexResult white--text text-h5">
              {{ item.name + ' ' + item.lastname }}
            </v-card-actions>
            <div style="font-size:14px;">
              <v-icon color="white">mdi-cake-variant</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-slide-group>
    </v-row> -->
  </div>
</template>

<script>
// import api from './../../../plugins/api'
import Cookie from 'js-cookie'
import VueJwtDecode from 'vue-jwt-decode'

// import { resolve } from 'path'
import TotalMensalVue from '../Components/CardsHome/TotalMensal.vue'
import TotalOfertaMensalVue from '../Components/CardsHome/TotalOfertaMensal.vue'
import TaxaMensalVue from '../Components/CardsHome/TaxaMensal.vue'
import TotalOfertasMissoes from '../Components/CardsHome/TotalOfertasMissoes.vue'
import ChartNovosMembros from '../Components/CardsHome/ChartNovosMembros.vue'
// import api from './../../../plugins/api'
import ChartTotalDizimoMeses from '../Components/CardsHome/ChartTotalDizimoMeses.vue'
import ChartTotalOfertaMonthVue from '../Components/CardsHome/ChartTotalOfertaMonth.vue'
import MediaPresencaPorCultoDomingoVue from '../Components/CardsHome/MediaPresencaPorCultoDomingo.vue'

export default {
  name: 'Home',
  components: {
    TotalMensalVue,
    TotalOfertaMensalVue,
    TaxaMensalVue,
    TotalOfertasMissoes,
    ChartNovosMembros,
    ChartTotalDizimoMeses,
    ChartTotalOfertaMonthVue,
    MediaPresencaPorCultoDomingoVue
  },
  data () {
    return {
      dialogEdit: false,
      dialog: false,
      activityLog: [
        { title: 'Total Dízimo Mês', amount: '', icon: 'mdi-account', color: 'cyan lighten-3' },
        { title: 'Total Customer', amount: 3433, icon: 'mdi-account-group-outline', color: 'green darken-2' },
        { title: 'Total Sale', amount: 3433, icon: 'mdi-account-group-outline', color: 'blue-grey darken-1' },
        {
          title: 'Pending Orders',
          amount: '',
          icon: 'mdi-account-group-outline',
          color: 'deep-orange darken-1'
        }
      ],
      desserts: {},
      loading: true,
      options: {},
      objSession: [],
      fechar: false,
      // Birthday: {
      //   name: '',
      //   lastname: '',
      //   day: 0,
      //   phone: ''
      // },
      showCardTaxa: true,
      showCardMissoes: true,
      posicao: 'left'
    }
  },
  mounted () {
    // this.getListBirthday()
    this.showCardTaxaMissoes()
  },
  watch: {
    options: {
      handler () {
        this.sumir()
      },
      deep: true
    }
  },
  methods: {
    onButtonClick (item) {
    },
    Cancel () {
      this.dialog = false
    },
    sumir () {
      setInterval(function () {
        this.fechar = true
      }, 3000)
    },
    open () {
      this.dialogEdit = true
    },
    closeEdit () {
      this.dialogEdit = false
      localStorage.removeItem('objEditCult')
      document.location.reload()
    },
    showCardTaxaMissoes () {
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      let obj = JSON.parse(decriptToken.infoChurch)
      if (obj[0].NomeIgreja !== 'IGREJA DO EVANGELHO QUADRANGULAR') {
        this.showCardTaxa = false
        this.showCardMissoes = false
        this.posicao = 'center'
      }
    }
  }
}
</script>

<style scoped>
.overlap-icon {
  position: absolute;
  top: -33px;
  text-align: center;
  padding-top: 12px;
}
.dashboard {
  width: 100%;
}
.teste {
  width: 100%;
}
canvas {
  background-color: lightblue;
  border: 1px solid blueviolet;
}
@media only screen and (max-width: 599px) {
  .chartTotalMonths {
    display: none;
  }
}
</style>
